module.exports = __webpack_public_path__ + "static/profil-361_optimized-c9bd29b507a97f0df46a1ff287501d3d.jpg";